import RemoveFavoritePopup from './Popups/RemoveFavoritePopup'
import EditShortcutsPopup from './Popups/EditShortcutsPopup'
import EditFavoritePopup from './Popups/EditFavoritePopup'
import usePopupState from 'hooks/usePopupState'

export const POPUPS = {
  editFavorite: 'editFavorite',
  removeFavorite: 'removeFavorite',
  editShortcuts: 'editShortcuts',
}

const Popups = () => {
  const { popup } = usePopupState()
  switch (popup?.type) {
    case 'editFavorite': return <EditFavoritePopup />
    case 'editShortcuts': return <EditShortcutsPopup />
    case 'removeFavorite': return <RemoveFavoritePopup relatedId={popup.relatedId} />
    default: return false
  }
}

export default Popups